module.exports = __webpack_public_path__ + "static/media/bar1.038e78ce.jpg";